@import '@wandb/weave/common/css/globals.less';

.create-report-prompt-tooltip {
  &&&&& {
    background-color: @gray800;
    padding: 24px;
    border-radius: 5px;
    &:before {
      background-color: @gray800;
    }
  }
}
